// extracted by mini-css-extract-plugin
module.exports = {"no_recommendations":"LvKpDbE6BU8coyyjAPAxZ","item":"_3XvDDEKfzsKScNE-rjvq_C","info":"_1y6xDVEkGKEFrhznviMr5d","why":"_1b99IV7ljm_gLWz4TJOI2W"};